<template>
  <div class="setInformation">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('setAccount.setInformation.nextPage') }}>{{
              $t('setAccount.setInformation.defineLedgerInformation')
            }}
          </div>
        </template>
        <div class="collapse-content">
          <el-steps :active="0" align-center>
            <el-step
              :title="$t('setAccount.distribution.essentialInformation')"
              icon="el-icon-success"
            ></el-step>
            <el-step
              :title="$t('setAccount.distribution.distributionLegalEntity')"
              icon="el-icon-time"
            ></el-step>
            <el-step
              :title="$t('setAccount.distribution.confirmledgerInformation')"
              icon="el-icon-place"
            ></el-step>
          </el-steps>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('setAccount.accountList.primaryLedger') }}
          </div>
        </template>
        <div class="collapse-content">
          <div class="creatCalendar">
            <!-- <el-button
              type="primary"
              icon="el-icon-plus"
              class="creatButton"
              @click="insertEvent(-1)"
            >{{$t('setAccount.viewAccount.newLegalEntity')}}</el-button>
            <el-button
              type="primary"
              icon="el-icon-delete"
              class="deteButton"
              @click="handleDelete('setInformationTable')"
            >{{$t('setAccount.viewAccount.detelLegalEntity')}}</el-button> -->
            <vxe-table
              border
              :auto-resize="true"
              show-overflow
              size="mini"
              ref="setInformationTable"
              :data="setInformationData"
              :edit-rules="validRules"
              :valid-config="{ autoPos: true, message: 'inline' }"
              :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
            >
              <!-- <vxe-table-column type="checkbox" width="80"></vxe-table-column> -->
              <!-- <vxe-table-column
                type="index"
                :title="$t('currenciesAndCalendar.queryCurrencies.index')"
                width="80"
              ></vxe-table-column> -->
              <vxe-table-column
                field="ledgerCode"
                :title="$t('setAccount.accountList.ledgerCode')"
                min-width="140"
                :edit-render="{ type: 'default' }"
              >
                <template v-slot:edit="scope">
                  <el-input
                    v-model="scope.row.ledgerCode"
                    @input="$refs.setInformationTable.updateStatus(scope)"
                    clearable
                  ></el-input>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="ledgerName"
                :title="$t('setAccount.setInformation.ledgerName')"
                min-width="140"
                :edit-render="{ type: 'default' }"
              >
                <template v-slot:edit="scope">
                  <el-input v-model="scope.row.ledgerName" clearable></el-input>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="accountChartCode"
                :title="$t('setAccount.setInformation.accountChartCode')"
                min-width="140"
                :edit-render="{ type: 'default' }"
              >
                <template v-slot:edit="scope">
                  <el-select v-model="scope.row.accountChartCode" clearable filterable>
                    <el-option
                      v-for="item in accountChartCodeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-slot="{ row }">{{
                  getSelectLabel(row.accountChartCode, accountChartCodeList)
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="accountCalendarCode"
                :title="$t('setAccount.setInformation.accountCalendarCode')"
                min-width="140"
                :edit-render="{ type: 'default' }"
              >
                <template v-slot:edit="scope">
                  <el-select v-model="scope.row.accountCalendarCode" clearable filterable>
                    <el-option
                      v-for="item in accountCalendarCodeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-slot="{ row }">{{
                  getSelectLabel(row.accountCalendarCode, accountCalendarCodeList)
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="currencyCode"
                :title="$t('setAccount.setInformation.currencyCode')"
                min-width="140"
                :edit-render="{ type: 'default' }"
              >
                <template v-slot:edit="scope">
                  <el-select v-model="scope.row.currencyCode" clearable filterable>
                    <el-option
                      v-for="item in currencyCodeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-slot="{ row }">{{
                  getSelectLabel(row.currencyCode, currencyCodeList)
                }}</template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/systemManage/accountManage';
  import BASE_API from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  // import AjaxSelect from '@/components/form-item/ajax-select';
  export default {
    name: 'setInformation',
    components: {},
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    data() {
      // var checkLedgerCode = (rule, value, callback) => {
      //   let reg =  /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/;
      //   if(!reg.test(value)){
      //     callback(new Error(this.$t("currenciesAndCalendar.rules.formatError")));
      //   }else{
      //     callback();
      //   }
      // }
      return {
        clearable: true,
        filterable: true,
        activeNames: ['1', '2'],
        validRules: {
          ledgerCode: [
            { required: true, message: this.$t('setAccount.accountList.ledgerCodeValidRules') },
            { min: 0, max: 30, message: this.$t('currenciesAndCalendar.rules.writeLength') },
          ],
          ledgerName: [
            { required: true, message: this.$t('setAccount.accountList.ledgerNameValidRules') },
            { min: 0, max: 120, message: this.$t('currenciesAndCalendar.rules.writeLength') },
          ],
          accountChartCode: [
            {
              required: true,
              message: this.$t('setAccount.accountList.accountChartCodeValidRules'),
            },
          ],
          accountCalendarCode: [
            {
              required: true,
              message: this.$t('setAccount.accountList.accountCalendarCodeValidRules'),
            },
          ],
          currencyCode: [
            {
              required: true,
              message: this.$t('setAccount.accountList.currencyCodeValidRules'),
            },
          ],
        },
        setInformationData: [
          {
            ledgerCode: '',
            ledgerName: '',
            accountCalendarCode: '',
            currencyCode: '',
            defaultExchangeType: 'Cooperate',
          },
        ], //表格信息
        accountChartCodeList: [], //会计科目表
        accountCalendarCodeList: [], //会计日历表
        currencyCodeList: [], //本位币列表
      };
    },
    mounted() {
      this.getCurrency();
      this.getCalendar();
      this.getSubject();
    },
    methods: {
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      // //增加
      // insertEvent(row) {
      //   if(this.setInformationData.length ==0){
      //     let setInformationTable = this.$refs.setInformationTable;
      //     let record = {};
      //     setInformationTable.insertAt(record, row).then(({ row }) => {
      //       setInformationTable.setActiveRow(row);
      //     });
      //     this.setInformationData = this.$refs.setInformationTable.getTableData().fullData;
      //   } else {
      //     this.$message({
      //       showClose: true,
      //       message: this.$t("setAccount.setInformation.onlyAddOnePice"),
      //       type: "error"
      //     });
      //   }
      // },
      // // 删除
      // handleDelete(tableTpye) {
      //   const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
      //   if (selectedList.length < 1) {
      //     this.$message({
      //       showClose: true,
      //       message: this.$t("personnel.table.chockedLows"),
      //       type: "error"
      //     });
      //     return;
      //   }
      //   this.$confirm(
      //     "<div><img src='./static/img/tips.png'/><div class='confirmTitle'>" +
      //       this.$t("confirm.delete") +
      //       "</div>" +
      //       "<div class='confirmContent'>" +
      //       this.$t("confirm.content") +
      //       "</div></div>",
      //     "",
      //     {
      //       dangerouslyUseHTMLString: true,
      //       cancelButtonText: this.$t("confirm.cancel"),
      //       confirmButtonText: this.$t("confirm.confirm"),
      //       center: true
      //     }
      //   )
      //     .then(() => {
      //       this.$refs[tableTpye].removeSelecteds();
      //       this.setInformationData = this.$refs.setInformationTable.getTableData().fullData;
      //       this.$message({
      //         showClose: true,
      //         type: "success",
      //         message: this.$t("personnel.table.deletSuccess")
      //       });
      //     })
      //     .catch(() => {
      //       this.$message({
      //         showClose: true,
      //         type: "info",
      //         message: this.$t("personnel.table.deletFalse")
      //       });
      //     });
      // },
      //校验
      fullValidEvent() {
        this.flag = true;
        let formList = ['setInformationTable'];
        let resultArr = [];
        let _self = this;
        function validates(formName) {
          let result = new Promise((resolve, reject) => {
            _self.$refs[formName].validate((valid) => {
              valid ? resolve() : reject();
            });
          });
          resultArr.push(result);
        }
        formList.forEach((item) => {
          validates(item); // 循环校验
        });
        this.setInformationData = this.$refs.setInformationTable.getTableData().fullData;
        if (this.setInformationData.length <= 0) {
          this.flag = false;
        }
        let childList = {
          setInformationData: this.setInformationData,
        };
        return Promise.all(resultArr)
          .then(() => {
            if (!this.flag) {
              this.$message({
                showClose: true,
                message: this.$t('personnel.table.tableTitle'),
                type: 'error',
              });
            } else {
              return childList;
            }
          })
          .catch(() => {});
      },
      //获取本位币
      async getCurrency() {
        let res = await this.$baseRequest.getCurrency();
        if (res) {
          this.currencyCodeList = res;
          this.currencyCodeList = this.currencyCodeList.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      //获取会计日历
      async getCalendar() {
        const calendar = await this.$axios.get(API.SEARCH_LISTACCOUNTCALENDARS);
        if (calendar.data.code == 0) {
          this.accountCalendarCodeList = calendar.data.data.map((item) => {
            return { value: item.calendarCode, label: item.calendarCode };
          });
        }
      },
      //获取会计科目表
      async getSubject() {
        // const { tenantCode } = this.userInfo.userInfo;
        const subject = await this.$axios.post(BASE_API.QUERY_SYSACCOUNTLIST);
        if (subject.data.code == 0) {
          this.accountChartCodeList = subject.data.data;
          this.accountChartCodeList = this.accountChartCodeList.map((item) => {
            return {
              label: item.accountTableCode,
              value: item.accountTableCode,
            };
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .setInformation .creatButton {
    background-color: rgb(98, 153, 254) !important;
    border: 1px solid rgb(98, 153, 254) !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .setInformation .deteButton {
    background-color: #fe8783 !important;
    border: 1px solid #fe8783 !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .setInformation .collapse-content {
    padding-top: 10px;
  }
  .setInformation .el-select {
    display: inline-block;
    position: relative;
    width: 100% !important;
  }
</style>
